// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DateBanner_wrapper__2vhUW","text-date":"DateBanner_text-date__2PIG0"};